import React, { useState, useEffect, useRef } from "react";
import { Shield, BarChart3, Users, Scale, UserRoundCheck, BrainCircuit, FileText, BadgeCheck, FileSearch, Award } from "lucide-react";

import Banner from "../components/Banner";
import bannerimg from "../assets/img/bannerbg.jpg";
import whoweare from "../assets/img/whoweare.svg";
import whatwedo from "../assets/img/whatwedo.jpg";
import industriesbg from "../assets/img/industriesbg.jpg";
import ourvaluebg from "../assets/img/ourvaluebg.jpg";
import lookingbg from "../assets/img/lookingbg.jpg";
import hexbox from "../assets/img/hexbox.svg";

import CTA from "../components/CTA";
import CountUp from "react-countup";

const sections = [
  { id: "intro", title: "1. Introduction" },
  { id: "purpose", title: "2. Platform Purpose" },
  { id: "information", title: "3. User Eligibility" },
  { id: "responsibilities", title: "4. User Responsibilities" },
  { id: "ownership", title: "5. Content Ownership" },
  { id: "research", title: "6. Research & Survey Usage" },
  { id: "rewards", title: "7. Points & Rewards System" },
  { id: "suspension", title: "8. Account Suspension" },
  { id: "liability", title: "9. Limitation of Liability" },
  { id: "privacy", title: "10. Privacy" },
  { id: "changesterms", title: "11. Changes to Terms" },
  { id: "contactus", title: "12. Contact" },
];

function About() {
    const [active, setActive] = useState("intro");
    const sidebarRef = useRef(null);
    const containerRef = useRef(null);

  
    useEffect(() => {
        const handleScroll = () => {
            const sidebar = sidebarRef.current;
            const container = containerRef.current;
            const contactSection = document.getElementById("contactus");

            if (!sidebar || !container || !contactSection) return;

            const scrollY = window.scrollY;
            const topOffset = 100;

            const containerTop = container.offsetTop;
            const sidebarHeight = sidebar.offsetHeight;

            // 👇 MAIN FIX
            const contactTop = contactSection.offsetTop;

            // ======================
            // ✅ STICKY LOGIC
            // ======================
            if (scrollY > containerTop - topOffset) {

            // 👉 jab tak contact section nahi aata
            if (scrollY + sidebarHeight + topOffset < contactTop) {
                sidebar.style.position = "fixed";
                sidebar.style.top = topOffset + "px";
            } else {
                // 👉 yaha unstick hoga (FIX)
                sidebar.style.position = "relative";
                sidebar.style.top =
                (contactTop - containerTop - sidebarHeight) + "px";
            }

            } else {
            sidebar.style.position = "relative";
            sidebar.style.top = "0px";
            }

            // ======================
            // ✅ SCROLL SPY
            // ======================
            const sections = document.querySelectorAll("section[id]");
            let current = "";

            sections.forEach((section) => {
            const sectionTop = section.offsetTop - 160;
            const sectionHeight = section.offsetHeight;

            if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
                current = section.getAttribute("id");
            }
            });

            if (current) {
            setActive(current);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

  return (
    <>
        <div className="position-relative">
            <Banner
            containerWidth="w-50"
            title="Where Industries Learn from the People Who Shape Them"
            subtitle="A professional research and insight platform connecting industry knowledge with real decision making"
            bgImage={bannerimg}
            headingcenter="text-center"
            />
            <section className="ptb60px communitysection px-3" data-aos="fade-up">
                <div className="container">
                    <div className="row align-items-center">

                        {/* LEFT CONTENT */}
                        <div className="col-md-6">


                        <div className="pr35px">
                            <div className="headingbox">
                                <h2 className="headinglg mb-4">
                                The Community Behind Smarter Decisions                                
                                </h2>
                            </div>

                            <p className="graytext mb-4 fs16px">
                            Industries & People is a professional research and insight platform designed to connect industry knowledge with real decision making. We work with experienced professionals across sectors and organizations seeking reliable, experience-backed perspectives.
                            </p>

                            <p className="textred fst-italic mb-4 fs16px bdrl2px ps-4">
                            We are not a social media platform. We do not facilitate public networking or casual connections.
                            </p>

                            <p className="graytext mb-4 fs16px">
                            Instead, we provide a structured environment where expertise is shared through surveys, research initiatives, and insight-led participation.
                            </p>

                        </div>

                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="col-md-6">

                            <div className="communityright text-center">

                                <img
                                    src={whoweare}
                                    alt="Who We Are"
                                    className="img-fluid whoweareimg"
                                />

                            </div>

                        </div>

                    </div>
                </div>
            </section>
            <section className="ptb60px whatwedosection px-3 bglightgray" data-aos="fade-up">
                <div className="container">

                    <div className="row align-items-center">

                        
                        <div className="col-md-6">

                            <div className="whatwedoimgbox pr40px" data-aos="fade-up">

                                <img
                                    src={whatwedo}
                                    alt="What We Do"
                                    className="whatwedoimg"
                                />

                            </div>

                        </div>

                        {/* RIGHT CONTENT */}
                        <div className="col-md-6 ps-lg-5">

                            <div className="whatwedoright ps-lg-3" data-aos="fade-up">

                                <div className="headingbox mb-4">
                                    <h2 className="headinglg">What We Do</h2>
                                </div>

                                <p className="graytext mb-5 fs16px fw500">
                                    We enable meaningful participation in industry research.
                                </p>

                                {/* BOX 1 */}
                                <div className="d-flex align-items-start whatwedobox mb-5">

                                    <div className="iconbox me-4">

                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="28"
                                            height="28"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <circle cx="12" cy="12" r="8" strokeWidth="2"/>
                                            <circle cx="12" cy="12" r="4" strokeWidth="2"/>
                                            <circle cx="12" cy="12" r="1" fill="white"/>
                                        </svg>

                                    </div>

                                    <div>

                                        <h3 className="boxheading mb-2 fw-bold">
                                            For Professionals
                                        </h3>

                                        <p className="graytext mb-0 fs16px">
                                            Take part in carefully curated surveys aligned with your
                                            experience, share informed opinions, and earn honorariums
                                            for your expertise.
                                        </p>

                                    </div>

                                </div>

                                {/* BOX 2 */}
                                <div className="d-flex align-items-start whatwedobox mb-5">

                                    <div className="iconbox me-4">

                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="28"
                                            height="28"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                d="M5 15L10 10L14 14L19 9"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M15 9H19V13"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>

                                    </div>

                                    <div>

                                        <h3 className="boxheading mb-2 fw-bold">
                                            For Organizations
                                        </h3>

                                        <p className="graytext mb-0 fs16px">
                                            Create tailored surveys, reach qualified participants,
                                            and collect insights grounded in real-world experience.
                                        </p>

                                    </div>

                                </div>

                                <p className="graytext mb-0 fs16px">
                                    This creates a balanced ecosystem where knowledge is valued and rewarded.
                                </p>

                            </div>

                        </div>

                    </div>
                </div>
            </section>
            <section className="ptb60px pb-0 whyexistsection px-3">
                <div className="container">
                    {/* HEADING */}
                    <div className="row justify-content-center">
                        <div className="col-lg-9 text-center">
                            <div className="headingbox mb-5">

                                <h2 className="headinglg mb-4">
                                    Why Industries & People Exists
                                </h2>

                                <p className="graytext fs18px mb-0">
                                    In many research environments, insights are diluted by irrelevant audiences or surface-level
                                    responses. We saw the need for a platform that prioritizes quality over quantity.
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center gy-4">
                        {/* ITEM */}
                        <div className="col-lg-3 col-md-6">
                            <div className="hexmainbox position-relative mx-auto">

                                {/* SVG BG */}
                                <img
                                    src={hexbox}
                                    alt="Hex Box"
                                    className="hexbgimg"
                                />

                                {/* CONTENT */}
                                <div className="hexcontent">

                                    <div className="hexicon">

                                        <UserRoundCheck size={34} />

                                    </div>

                                    <h3 className="hexheading">
                                        Right Professionals
                                    </h3>

                                    <p className="hextext mb-0">
                                        Surveys reach the right professionals with relevant experience
                                    </p>

                                </div>

                            </div>

                        </div>

                        {/* ITEM */}
                        <div className="col-lg-3 col-md-6">

                            <div className="hexmainbox position-relative mx-auto hexbgimgrotate">

                                <img
                                    src={hexbox}
                                    alt="Hex Box"
                                    className="hexbgimg"
                                />

                                <div className="hexcontent">

                                    <div className="hexicon">

                                        <BrainCircuit size={34} />

                                    </div>

                                    <h3 className="hexheading">
                                        Informed Opinions
                                    </h3>

                                    <p className="hextext mb-0">
                                        Perspectives are informed, not speculative
                                    </p>

                                </div>

                            </div>

                        </div>

                        {/* ITEM */}
                        <div className="col-lg-3 col-md-6">

                            <div className="hexmainbox position-relative mx-auto">

                                <img
                                    src={hexbox}
                                    alt="Hex Box"
                                    className="hexbgimg"
                                />

                                <div className="hexcontent">

                                    <div className="hexicon">

                                        <FileSearch size={34} />

                                    </div>

                                    <h3 className="hexheading">
                                        Transparent Process
                                    </h3>

                                    <p className="hextext mb-0">
                                        Participation is transparent and respectful
                                    </p>

                                </div>

                            </div>

                        </div>

                        {/* ITEM */}
                        <div className="col-lg-3 col-md-6">

                            <div className="hexmainbox position-relative mx-auto">

                                <img
                                    src={hexbox}
                                    alt="Hex Box"
                                    className="hexbgimg"
                                />

                                <div className="hexcontent">

                                    <div className="hexicon">

                                        <Award size={34} />

                                    </div>

                                    <h3 className="hexheading">
                                        Fair Recognition
                                    </h3>

                                    <p className="hextext mb-0">
                                        Expertise is acknowledged fairly through honorariums
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>
            <section className="ptb60px ourvaluessection px-3" data-aos="fade-up">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12 text-center">
                            <div className="position-relative overflow-hidden rounded-4">
                                <img
                                    src={industriesbg}
                                    alt="What We Do"
                                    className="w-100"
                                />
                                {/* OVERLAY */}
                                <div className="imageoverlay"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
            <section className="ptb60px ourvaluessection bglightgray px-3" data-aos="fade-up">
                <div className="container">
                    <div className="row align-items-center">

                        {/* LEFT CONTENT */}
                        <div className="col-md-6">


                        <div className="pr35px">
                            <h2 className="headinglg mb-4">Our Values</h2>

                            <p className="graytext mb-4 fs16px">Everything we do is guided by simple principles</p>

                            <ul className="ourvaluelist">
                                <li>Credibility before scale</li>
                                <li>Insight before influence</li>
                                <li>Respect for expertise and time</li>
                                <li>Transparency in research</li>
                            </ul>                       

                            <p className="graytext mb-4 fs16px">These values shape how our platform operates and how we engage with our community.</p>

                        </div>

                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="col-md-6">

                            <div className="communityright text-center">

                                <img
                                    src={ourvaluebg}
                                    alt="Our Values"
                                    className="img-fluid rounded-5 ourvalueimg"
                                />

                            </div>

                        </div>

                    </div>
                </div>
            </section>
            <section className="researchsection position-relative overflow-hidden ptb60px px-3">

                {/* SHAPE */}
                <div className="researchshape"></div>

                <div className="container position-relative z-1">

                    {/* HEADING */}
                    <div className="row justify-content-center">

                        <div className="col-lg-8 text-center">

                            <div className="headingbox mb60px">

                                <h2 className="text-white headinglg mb-4">
                                    Our Research Approach
                                </h2>

                                <p className="text-white fs16px">
                                    We follow a structured and ethical approach to research and insight collection.
                                </p>

                            </div>

                        </div>

                    </div>

                    {/* COUNTER BOX */}
                    <div className="row gy-4 justify-content-center ">

                        {/* ITEM */}
                        <div className="col-lg-3 col-md-6">

                            <div className="counterbox text-center">

                                <h3 className="countertitle">

                                    <CountUp
                                        end={100}
                                        duration={3}
                                        enableScrollSpy
                                        scrollSpyOnce
                                    />

                                    +

                                </h3>

                                <p className="countertext mb-0">
                                    Industries
                                </p>

                            </div>

                        </div>

                        {/* ITEM */}
                        <div className="col-lg-3 col-md-6">

                            <div className="counterbox text-center">

                                <h3 className="countertitle">

                                    <CountUp
                                        end={10}
                                        duration={3}
                                        enableScrollSpy
                                        scrollSpyOnce
                                    />

                                    k+

                                </h3>

                                <p className="countertext mb-0">
                                    Professionals
                                </p>

                            </div>

                        </div>

                        {/* ITEM */}
                        <div className="col-lg-3 col-md-6">

                            <div className="counterbox text-center">

                                <h3 className="countertitle">

                                    <CountUp
                                        end={50}
                                        duration={3}
                                        enableScrollSpy
                                        scrollSpyOnce
                                    />

                                    +

                                </h3>

                                <p className="countertext mb-0">
                                    Countries
                                </p>

                            </div>

                        </div>

                        {/* ITEM */}
                        <div className="col-lg-3 col-md-6">

                            <div className="counterbox text-center">

                                <h3 className="countertitle">

                                    <CountUp
                                        end={95}
                                        duration={3}
                                        enableScrollSpy
                                        scrollSpyOnce
                                    />

                                    %

                                </h3>

                                <p className="countertext mb-0">
                                    Satisfaction
                                </p>

                            </div>

                        </div>

                    </div>

                </div>

            </section>
            {/* <section className="ptb60px lookingbgsection px-3" data-aos="fade-up">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12 text-center">
                            <div className="position-relative overflow-hidden rounded-4">
                                <img
                                    src={lookingbg}
                                    alt="Looking Ahead"
                                    className="w-100 lookingbgimg"
                                />                            
                                <div className="imageoverlay"></div>                            
                                <div className="lookingahead text-white text-left">
                                    <h2 className="headinglg text-white mb-3">
                                        Looking Ahead
                                    </h2>
                                    <p className="fs16px mb-0">
                                        As markets grow more complex, informed perspectives become even more valuable.
                                        We're committed to growing responsibly and staying focused on research quality.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}  
            <CTA />
        </div>
    </>
  );
}
export default About;